import styled from 'styled-components';
import {
	H1
} from '../base';
import media from '../base/media';
import { alignToContainerLeft, alignToContainerRight } from '../../helpers/spacings/spacings';
import { fadeInAndUp, fadeInAndRight } from '../base/keyframes/fades';

export const Wrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: ${({ imageRightSideOnly }) => (imageRightSideOnly ? 'flex-end' : 'center')};
	max-width: 1920px;
	margin: 0 auto;
	padding-top: ${({ theme }) => theme.header.headerHeightMobile};

	${media.desktopSmall`
		flex-direction: row;
	`}

	${media.desktopSmall`
		padding-top: ${props => props.theme.header.headerHeightDesktop};
	`}
`;

export const Content = styled.div`
	${alignToContainerLeft};
	${alignToContainerRight};

	${media.desktopSmall`
		width: 45rem;
		position: absolute;
		top: ${props => props.theme.header.headerHeightDesktop};
		left: 0;
		right: 0;
	`}

	@media(max-width: 1540px) {
		margin-left: 5rem;
		margin-right: 5rem;
	}

	${media.desktopSmall`
		padding-top: 10rem;
	`}

	${media.desktopLarge`
		padding-top: 13rem;
	`}
`;

export const FiltersWrapper = styled.div`

	${alignToContainerLeft};
	${alignToContainerRight};
	position: relative;
	margin-top: 40px;

	${media.desktopSmall`
		position: absolute;
		bottom: 13rem;
		left: 0;
		right: 0;
		margin-top: 0;
	`}

	@media(max-width: 1540px) {
		margin-left: 5rem;
		margin-right: 5rem;
	}

`;

export const HeroTitle = styled(H1)`
	color: ${({ theme }) => theme.hero.heroTitleColor};
	transition: color ${({ theme }) => theme.theming.nightDayTransitionDuration} ease;
	opacity: 0;
	animation: ${fadeInAndUp} 400ms ease 300ms forwards;
	margin-top: 2rem;
	margin-bottom: 2rem;

	${media.desktopSmall`
		margin-top: 0;
		margin-bottom: 6rem;
		font-size: 6.6rem;
		line-height: 7.2rem;
	`}
`;

export const HeroText = styled.div`
	color: ${({ theme }) => theme.hero.heroTextColor};
	transition: color ${({ theme }) => theme.theming.nightDayTransitionDuration} ease;
	opacity: 0;
	animation: ${fadeInAndRight} 400ms ease 450ms forwards;
`;
